import React from "react";
import Header from "../../../component/header/Header";
import Table from "../../../component/table/Table";
import tableData from "../../../utils/prodottiAnagraficheData.json";

const columns = [
  { field: "img", headerName: "IMG", width: 62 },
  { field: "cod", headerName: "COD.", width: 185 },
  { field: "nomeProdotto", headerName: "Nome del prodotto", width: 295 },
  { field: "categoria", headerName: "Categoria", width: 200 },
  { field: "um", headerName: "UM", width: 80 },
  { field: "pzVendita", headerName: "Pz di vendita", width: 125 },
  { field: "costoServizio", headerName: "Costo servizio", width: 130 },
  { field: "ricavoU", headerName: "Ricavo U.", width: 98 },
  { field: "acquistato", headerName: "Acquistato", width: 130 },
  { field: "venduto", headerName: "Venduto", width: 130 },
  { field: "ricavoTot", headerName: "Ricavo tot", width: 130 },
  { field: "utente", headerName: "Utente", width: 85 },
  { field: "azioni", headerName: "Azioni", width: 95 },
];


const ProdottiAnagrafiche = () => {
  return (
    <>
      <Header />
      <div className="pageTemplate ">
        <Table
          data={tableData}
          columns={columns}
          navData={"prodottiAnagrafiche"}
        />
      </div>
    </>
  );
};

export default ProdottiAnagrafiche;
